import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { BrandMark } from '../components/ui/BrandLogo';
import { FiSearch, FiBell, FiSettings, FiUser, FiZap } from 'react-icons/fi';

export const TopNav = () => {
  return (
    <header className="h-16 border-b border-slate-800/80 bg-slate-950/80 backdrop-blur-md flex items-center justify-between px-6 sticky top-0 z-20">
      <div className="flex items-center gap-4 flex-1">
        <div className="md:hidden">
          <BrandMark className="w-8 h-8" />
        </div>
        <div className="relative w-full max-w-md hidden md:block group">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-cyan-400 transition-colors" />
          <input 
            type="text" 
            placeholder="Query site data (RFIs, Tasks, Nodes)..." 
            className="w-full bg-slate-900/50 border border-slate-800 group-hover:border-slate-700 focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/50 rounded-sm py-1.5 pl-9 pr-4 text-[13px] text-slate-300 placeholder-slate-600 outline-none transition-all font-mono"
          />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 border-r border-slate-800 pr-4">
          <button className="p-2 text-slate-400 hover:text-cyan-400 transition-colors relative group">
            <SafeIcon icon={FiBell} />
            <span className="absolute top-2 right-2 w-1.5 h-1.5 bg-yellow-500 rounded-full animate-pulse shadow-[0_0_10px_rgba(234,179,8,0.8)]"></span>
            <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 px-2 py-1 bg-slate-900 border border-slate-800 rounded-sm text-[10px] text-slate-400 opacity-0 group-hover:opacity-100 pointer-events-none transition-all whitespace-nowrap z-50">
              3 Active Alerts
            </div>
          </button>
          <button className="p-2 text-slate-400 hover:text-cyan-400 transition-colors">
            <SafeIcon icon={FiZap} />
          </button>
          <button className="p-2 text-slate-400 hover:text-cyan-400 transition-colors">
            <SafeIcon icon={FiSettings} />
          </button>
        </div>
        
        <div className="flex items-center gap-3 pl-2 cursor-pointer group">
          <div className="text-right hidden sm:block">
            <div className="text-[11px] font-bold text-slate-200 group-hover:text-cyan-400 transition-colors uppercase tracking-wider">D. Vance</div>
            <div className="text-[9px] text-slate-500 font-mono uppercase tracking-[0.1em]">Site Controller</div>
          </div>
          <div className="w-8 h-8 rounded-sm bg-slate-800 border border-slate-700 flex items-center justify-center text-cyan-500 group-hover:border-cyan-500/50 transition-all">
            <SafeIcon icon={FiUser} />
          </div>
        </div>
      </div>
    </header>
  );
};